<script lang="ts" setup>
import Author from '@/pages/hence/author/components/Author.vue'
import List from '@/pages/hence/author/components/List.vue'
import Newsletter from '@/pages/hence/components/Newsletter.vue'
import type { IArticleFilterParams } from '~/api/types/filter'
import useSeo from './seo'

const route = useRoute()
const { article } = useApi()
const id = route.params.id as string
const page = parseInt(route.query.page as string) || 1
const { data: authorData } = await article.getArticleAuthor(id)
const author = computed(() => authorData.value?.data)
const filter = {
  author_id: author.value?.id || '',
  page: page,
  per_page: 6
} as IArticleFilterParams
const { data: articleData, execute } = await article.getArticles(filter)
const articleRes = computed(() => articleData.value?.data.list)

watch(
  () => route.query.page,
  (page) => {
    filter.page = parseInt(page as string) || 1
    execute()
    window.scrollTo(0, 0)
  }
)

useSeo(author.value)
</script>

<template>
  <section class="hence">
    <Author :author="author" />
    <List :data="articleRes" />
    <!-- <Newsletter class="hence__full" /> -->
  </section>
</template>

<style lang="scss" scoped>
.hence {
  @include max-media(767) {
    position: relative;
    z-index: 2;
    transform: translateY(toRem(100));
    margin-top: toRem(-100);
  }

  &__full {
    margin-left: toRem(-24);
    margin-right: toRem(-24);
  }
}
</style>
